import { render, staticRenderFns } from "./Pedestal.vue?vue&type=template&id=56c4f78e&"
import script from "./Pedestal.vue?vue&type=script&lang=js&"
export * from "./Pedestal.vue?vue&type=script&lang=js&"
import style0 from "./Pedestal.vue?vue&type=style&index=0&id=56c4f78e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports